import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { formatNumber } from "_common/utils/formatValue";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { useQuery } from "@tanstack/react-query";
import { PriceApi } from "states/api/price";
import classNames from "classnames";
import i18next from "i18next";
import { StockApi } from "states/api/stock";
import { get } from "lodash";

const Stock = observer(() => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const {
    authStore: { stocks },
  } = useStores();

  const [time, setTime] = useState();
  const [gameList, setGameList] = useState(stocks);

  const { data, refetch } = useQuery(
    ["stock", "price"],
    () =>
      StockApi.getList({
        params: {
          page: 1,
          limit: 50,
          ...params,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date().getTime());
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [time]);

  useMemo(() => {
    const result = stocks.map((item) => {
      const price = data?.find(
        (obj) => obj?.ticker?.toLowerCase() === item?.code
      );

      const priceChange = Number(get(price, "priceChange", 0));
      const currentPrice = Number(get(price, "currentPrice", 0));
      const random = Math.floor(Math.random() * 100 + 1) / 1000;

      return {
        ...item,
        price: {
          ...price,
          priceChange: priceChange + random,
          currentPrice: currentPrice + currentPrice * random,
        },
      };
    });
    setGameList(result);
  }, [stocks, data, time]);

  return (
    <div className="coin-list">
      <div className="list">
        <div className="item header">
          <div className="col1 text-[#707A8A]">Mã CK</div>
          <div className="col2 text-[#707A8A]">{i18next.t("latest_price")}</div>
          <div className="col3 text-[#707A8A]">24H Số lượng</div>
        </div>
        {gameList?.map((item) => (
          <a
            href={`/trade?symbol=${item?.code}&type=stock`}
            className="item"
            key={item?.id}
          >
            <div className="col1 !flex-row">
              <img
                src={item?.image_url}
                alt=""
                width="20"
                height="20"
                className="mr-[10px]"
              />
              <p className="name uppercase">
                <b>{item?.code}</b>
              </p>
            </div>
            <div className="col2">
              <span
                className={classNames({
                  "text-green": item?.price?.priceChange > 0,
                  "text-red": item?.price?.priceChange <= 0,
                })}
              >
                {formatNumber(item?.price?.currentPrice, "0,0.[00000]")}
              </span>
            </div>
            <div className="col3">
              <span
                className={classNames("tag ", {
                  green: item?.price?.priceChange > 0,
                  red: item?.price?.priceChange <= 0,
                })}
              >
                {formatNumber(item?.price?.priceChange, "0,0.[00]")}%
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
});

export default Stock;
